import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';;
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TiretPipe } from 'src/app/pipe/tiret.pipe';
import { GroupeFormationModel } from 'src/models/groupe-formation/groupe-formation-model';
import { ScormPackageLocaleModel, ScormPackageModel } from 'src/models/scormPackageModel';
import { GroupeFormationService } from 'src/services/groupe-formation.service';
import { UtilisateurService } from 'src/services/utilisateur.service';
import moment from'moment';

@Component({
    selector: 'app-groupe-formation-card',
    templateUrl: './groupe-formation-card.component.html',
    styleUrls: ['./groupe-formation-card.component.scss'],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        MatProgressSpinner,
        TiretPipe
    ]
})
export class GroupeFormationCardComponent implements OnInit {
  momentDate = moment;
  @Input() showDescriptionFn!: (scormPackage: ScormPackageModel, formationGroupeId: number) => void;
  @Input() formation!: GroupeFormationModel;
  formationBd!: GroupeFormationModel;
  dataSavedChanged: boolean = true;
  selectedAllParticipants: boolean = false;
  isLoading: boolean = false;

  constructor(
    public translate: TranslateService,
    private utilisateurService: UtilisateurService,
    public groupeFormationService: GroupeFormationService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.formationBd = JSON.parse(JSON.stringify(this.formation));
    this.selectedAllParticipants = this.formation.utilisateurs.every(user => user.estPresent == true);
  }

   getLocalizedContent(locales: ScormPackageLocaleModel[]): ScormPackageLocaleModel {
      const currentLang = this.translate.currentLang || 'fr';
      return locales.find(locale => locale.langue.toLowerCase() === currentLang) || locales[0];
    }

    getParticipants(){
      return this.formation.utilisateurs.filter(user => user.utilisateurId != this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId);
    }

    selectedAllParticipantsFn(){
      this.selectedAllParticipants = !this.selectedAllParticipants;
      this.formation.utilisateurs.forEach(user => {
        user.estPresent = this.selectedAllParticipants;
      });
    }

  selectedOne(isChecked: boolean, utilisateurId: number) {
    this.formation.utilisateurs.forEach(user => {
      if (user.utilisateurId == utilisateurId) {
        user.estPresent = isChecked;
      }
    });
    this.selectedAllParticipants = this.formation.utilisateurs.every(user => user.estPresent == true);
  }

    save(){
      this.isLoading = true;
      this.groupeFormationService.EnregistrerPresenceFormationGroupe( this.formation.id, this.formation).subscribe(
        res => {
          this.formationBd = JSON.parse(JSON.stringify(this.formation));
          this.isLoading = false;
        }
      );
    }

    donneeNonEnregistre(): boolean {
      return this.formation.utilisateurs.some(user => {
        const userBd = this.formationBd.utilisateurs.find(
          u => u.utilisateurId === user.utilisateurId
        );
        return userBd && userBd.estPresent !== user.estPresent;
      });
    }

    nombreDePresences(){
      return this.formation.utilisateurs.filter(user => user.estPresent == true).length;
    }

    isNumberAssistValid(){
      return this.formation.utilisateurs.filter(user => user.estPresent == true).length >= 2;
    }

    isSaved(){
     return  !this.donneeNonEnregistre();
    }

    isValid(){
      if (this.isNumberAssistValid() && this.isDateStartedValid() && this.isSaved()) {
        this.showDescriptionFn(this.formation.package!, this.formation.id);
      }
    }

    isDateStartedValid(){
      return this.momentDate(this.formation.dateHeurePrevue).startOf('day').isBefore(this.momentDate().add(1, 'days').startOf('day'));
    }

    disabledButton(){
      return this.formation.utilisateurs.every(user => user.estPresent == false) || this.donneeNonEnregistre() === false;
    }
}
